import { Component } from "react";
import RoundedIconButton from "../../../components/RoundedIconButton";
import { FilterList, Refresh } from "@mui/icons-material";
import swal from "sweetalert";
import request from "../../../request";
import { CircularProgress } from "@mui/material";
import CenteredMessage from "../../../components/CenteredMessage";
import MapMarkers from "../../../components/MapMarkers";
import Filters from "../../../components/Filters";
import StyledLink from "../../../components/StyledLink";
import links from "../../../links";


export default class InstallationsMap extends Component {

   state = {
      loading: false,
      installations: null,
      filters: {
         from: undefined,
         to: undefined
      },
      filterModelOpen: false
   }

   fetchInstallations = async (foreground=false) => {
      try {

         this.setState({ loading: true });

         const { from, to } = this.state.filters;
         const params = {};
         if (from) params.from = from;
         if (to) params.to = to;

         const res = await request.get('/api/general/reports/installation-locations', { params });
         const { installations } = res.data;
         this.setState({ installations, loading: false });

      } catch (err) {
         if (foreground)
            swal("Error", err.message, "error");
      } finally {
         this.setState({ loading: false });
      }

   }

   componentDidMount() {
      this.fetchInstallations();
   }

   render() {

      const { installations, loading } = this.state;
      let content;

      if (loading) {
         content = <div className="flex items-center justify-center h-full">
            <CircularProgress />
         </div>
      } else if (installations === null) {
         content = <CenteredMessage message="Installation locations not fetched" onRefresh={() => this.fetchInstallations(true)} />
      } else {
         const markers = installations.map(installation => {
            const { _id, status, location } = installation;
            const caption = <>
               Installation <StyledLink to={links.installation(_id)}>
                  #{_id.slice(-4)}
               </StyledLink> – {status.toUpperCase()}
            </>

            return { caption, location };
         });

         content = <MapMarkers
            markers={markers}
            height="100%"
         />
      }

      return <div className="rounded-xl border-[1px] overflow-hidden">
         <div className="h-[400px] border-y-[1px]">
            {content}
         </div>
         <div className="flex justify-end py-2 px-4 gap-1">
            <RoundedIconButton 
               size='small'
               onClick={() => this.setState({ filterModelOpen: true })}
            >
               <FilterList fontSize="small" />
            </RoundedIconButton>
            <RoundedIconButton
               size='small'
               color='secondary'
               onClick={() => this.fetchInstallations(true)}
            >
               <Refresh fontSize="small" />
            </RoundedIconButton>
            {
               this.state.filterModelOpen && <Filters
                  onClose={filters => {
                     this.setState({ filterModelOpen: false });
                     if (filters)
                        this.setState({ filters }, () => this.fetchInstallations(true));
                  }}
                  filters={[
                     {
                        field: 'from',
                        label: 'From',
                        type: 'date',
                        value: this.state.filters.from
                     },
                     {
                        field: 'to',
                        label: 'To',
                        type: 'date',
                        value: this.state.filters.to
                     }
                  ]}
               />
            }
         </div>
      </div>
   }
}